import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockEntryModel } from "../stockEntryModel";
import { IStockEntryFields } from "../stockEntryService"
import useNavModel from "@/model/navModel";
import { useDictModel } from "../../../base/dict/dictModel";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys } = useStockEntryModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const { getTreeNodeOne } = useDictModel();

    const onLook = (text: string) => {
        replaceNav(selectedNavId, "4-5-3", { id: text as string, mode: "look" }, true);
    }
    const columns: ColumnsType<IStockEntryFields> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 120,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '入库单号',
            title: Locale["Stock In Doc No."],
            dataIndex: 'tradeCode',
            render: text => <span onClick={() => onLook(text)} className="click-span">{text}</span>
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            dataIndex: 'tradeTypeCode',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                }else{
                    return ""
                }
            }
        }, {
            // title: '入库时间',
            title: Locale["Stock-in Time"],
            dataIndex: 'stockIoTime',
        }, {
            // title: '入库数量',
            title: Locale["Stock-in Qty"],
            dataIndex: 'inTotal',
        }, {
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            dataIndex: 'billingClerk',
        }, {
            // title: '制单时间',
            title: Locale["Creation Time"],
            dataIndex: 'billingTime',
            render: (text) => momentFormat(text)

        }
    ];
    useEffect(() => {
        loadData().then();
    }, [])
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockEntryFields[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.id as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
